import moment from "moment";

export const getLocalizedDate = (date) => {
  if (!date) return;
  return moment(date).format('DD.MM.YY');
}